<template>
  <div>

    <div>
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="所属分类">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>  <el-button  @click="goTo(0)" class="category add" style="">新增</el-button>
      </el-form>

    </div>
    <el-table
        :data="tableData"
        style="width: 100%">
      <el-table-column
          label="ID"
          width="180">
        <template slot-scope="scope">
          <span style="" >{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="标题"
          width="180">
        <template slot-scope="scope">
          <span style="" v-html="scope.row.name"></span>
        </template>
      </el-table-column>
      <el-table-column
        label="所属类型"
       >
      <template slot-scope="scope">
        <span style="">{{ scope.row.type }}</span>
      </template>
      </el-table-column>
      <el-table-column label="操作"  width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="goTo(scope.row.id)">编辑</el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deleteType(scope.$index,scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import axios from "axios";
// import Dialog from "@/views/pages/getContentView.vue"


export default {
  name: "TypeView",
  data() {
    return {
      form:{
        type:''
      },
      tableData: [],
      options: [
        {label:'所有',value:""},
        {label:'Air compressor Types',value:"type"},
        {label:'Lubrication Way',value:"way"}
      ],
      id: '',
      total: 100,
    }
  },
  components:{
  },
  created() {
    this.getCate();
  },
  methods: {
    goTo(id){
      this.$router.push('/gettype/'+id)
    },
    getCate(){
      var type = this.form.type
      var str = '';
      if(type) str = "?type="+type
      axios.get('/api/Type/list.html'+str).then((res)=>{
        if(res.data.code == 200){
          this.tableData = res.data.data;
        }
      });
    },

    onSubmit() {
      this.getCate()
    },
    deleteType(index,row){
      let tdata = this.tableData;
      this.$confirm("是否确认删除","提示",{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
      }).then(function (){
        axios.delete('/api/Type/deleteType.html',{data:{id:row.id}}).then((res)=>{
          tdata.splice(index, 1);
          alert(res.data.msg)
        });
      }).catch(function (){

      })

    }
  }
};
</script>
<style scoped lang=''>
</style>